import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useGetBrokerAccounting } from "../../../../../../api/queries/brokers.queries";

export const accountingSchema = z.object({
	iban: z.string().optional().or(z.literal("")),
	bic: z.string().optional().or(z.literal("")),
	executiveFirstname: z.string().min(1, "Le prénom est requis"),
	executiveLastname: z.string().min(1, "Le nom est requis"),
	executiveEmail: z.email("Email invalide"),
	executivePhone: z.string().min(1, "Le téléphone est requis"),
});

export type AccountingFormData = z.infer<typeof accountingSchema>;

export const useAccountingTab = (id: number) => {
	const form = useForm<AccountingFormData>({
		resolver: zodResolver(accountingSchema),
	});

	const {
		data: brokerAccounting,
		isLoading,
		error,
	} = useGetBrokerAccounting(id);

	useEffect(() => {
		if (brokerAccounting) {
			const managerUser = brokerAccounting.users.find(
				(user) => user.isSignatory === true,
			);

			form.reset({
				iban: brokerAccounting.brokerDetails?.iban || "",
				bic: brokerAccounting.brokerDetails?.bic || "",
				executiveFirstname: managerUser?.firstname || "",
				executiveLastname: managerUser?.lastname || "",
				executiveEmail: managerUser?.email || "",
				executivePhone: managerUser?.mobilePhone || "",
			});
		}
	}, [brokerAccounting, form]);

	return { form, isLoading, error };
};
